module.exports = __webpack_public_path__ + "static/img/BuyPackage-Cart.629124d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/BuyPackage-Cart.png
// module id = uDjP
// module chunks = 0